
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/meet-the-team",
      function () {
        return require("private-next-pages/meet-the-team/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/meet-the-team"])
      });
    }
  